import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/additionaleffort/list",
    name: "AdditionalEffortOverview",
    component: () => import("@/views/additionaleffort/AdditionalEffortOverview"),
    meta: {
      title: "nav.additionaleffort.overview",
      requiresAuth: true,
      // Either right opens the page: it lists the catalogue's records and its packets, and shows
      // whichever of the two the reader may read (`services/catalogPackets.js`).
      requiresPermissions: [PERMISSIONS.VIEW_ADDITIONAL_EFFORT_GENERAL, PERMISSIONS.VIEW_PACKET_GENERAL],
    },
  },
  {
    path: "/additionaleffort/create",
    name: "AdditionalEffortCreate",
    component: () => import("@/views/additionaleffort/AdditionalEffortCreate"),
    meta: {
      title: "additionaleffort.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_ADDITIONAL_EFFORT_GENERAL],
    },
  },
  {
    path: "/additionaleffort/:additionalEffortId",
    name: "AdditionalEffortDetail",
    props: true,
    component: () => import("@/views/additionaleffort/AdditionalEffortDetail"),
    meta: {
      title: "nav.additionaleffort.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_ADDITIONAL_EFFORT_GENERAL],
    },
  },
]
